import { insightsMutationTypes } from './mutation-types';

export const mutations = {
  [insightsMutationTypes.FANBASE_EVOLUTION_INSIGHTS] (state, { insights }) {
    state.fanbaseEvolution.insights = insights;
  },

  [insightsMutationTypes.INTERACTIONS_OVER_TIME_INSIGHTS] (state, { insights }) {
    state.interactionsOverTime.insights = insights;
  },
};
